import { useGameStore } from '../stores/gameStore';
import { GAME_STATES } from '../utils/constants';
import { LastQuestionCountdown } from './LastQuestionCountdown';
import { QuestionCountdown } from './QuestionCountdown';
import { ResultsCountdown } from './ResultsCountdown';

const Countdown = () => {
	const questionNumber = useGameStore((state) => state.questionNumber);
	const totalQuestions = useGameStore((state) => state.totalQuestions);
	const countdown = useGameStore((state) => state.countdown);

	const gameState = useGameStore((state) => state.gameState);

	const displayLastQuestionAnimation = questionNumber + 1 >= totalQuestions;

	if (displayLastQuestionAnimation && gameState !== GAME_STATES.ENDED && gameState !== GAME_STATES.RESULTS_COUNTDOWN) {
		return <LastQuestionCountdown countdown={countdown} />;
	}

	if (gameState === GAME_STATES.RESULTS_COUNTDOWN) {
		return <ResultsCountdown countdown={countdown} />;
	}

	return <QuestionCountdown gameState={gameState} countdown={countdown} />;
};

export default Countdown;
